import Dexie, { Table } from 'dexie';
import { Word, StudySession, Achievement, UserProgress, BlogPost } from '../types';

class LinguaTrackerDB extends Dexie {
  words!: Table<Word>;
  sessions!: Table<StudySession>;
  achievements!: Table<Achievement>;
  progress!: Table<UserProgress>;
  blogPosts!: Table<BlogPost>;

  constructor() {
    super('linguaTracker');
    
    // Increase version number to handle the version mismatch
    this.version(20).stores({
      words: '++id, word, date, mastery, nextReview',
      sessions: '++id, date',
      achievements: '++id',
      progress: '++id',
      blogPosts: '++id, date'
    });
  }

  async initialize() {
    try {
      // Delete the database if version mismatch occurs
      const currentVersion = await Dexie.getDatabaseNames()
        .then(names => names.includes('linguaTracker'));
      
      if (currentVersion) {
        await this.delete();
        await this.open();
      }
      
      return true;
    } catch (error) {
      console.error('Database initialization failed:', error);
      return false;
    }
  }
}

export const db = new LinguaTrackerDB();